import axios, { AxiosError } from 'axios';
import { Api } from '../../axios-config';

export interface IDetalheHoraExtra {
  idfun: string;
  tipo: string;
  datalan: Date;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

export interface IRAli {
  nome: string;
  fazenda: string;
  fazenda1: string;
  marco: boolean;
  confirmo: boolean;
}

const create = async (dados: IDetalheHoraExtra): Promise<void | Error> => {
  try {
    await Api.post('/pontosalimentacao', dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const relatorioAli = async (datas: string, confirmado: boolean): Promise<IRAli[] | Error> => {
  try {
    const urlRelativa = `/rali?datas=${datas}&confirmado=${confirmado}`;
    const { data } = await Api.get(urlRelativa);
    if (data) {   
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const AlimentacaoService = {
  create,
  relatorioAli,
};